
<template>
  <div>
    <CJumbotron
      class="custom-jumbotron"
      :style="{ backgroundImage: `url(${backgroundBannerPro})` }"
    >
      <CContainer>
        <CRow>
          <CCol sm="12" lg="12" class="element-50 mt-5 text-center custom-center-pro">
            <div>
              <img
                style="max-width: 100%;"
                class="text-center"
                src="../assets/img/textProWhite.png"
              />
            </div>
            <a href="https://pickiddo.com/PICKIDDO_FE/#/RegisterProClass">
              <CButton
                color="info"
                class="mt-5"
                size="lg"
                style="width: 200px; height: 70px"
                >Register As Pro</CButton
              >
            </a>
            <br /><br />
            <br /><br />
          </CCol>
        </CRow>
      </CContainer>
    </CJumbotron>
    <CCol style="background: #5fc8f0" sm="12" lg="12">
      <CRow>
        <CCol sm="8" lg="8" class="mb-5">
          <h1 class="custom-pro-title mt-5 ml-5" data-aos="fade-up">
            From Pro to Protégés
          </h1>

          <h3
            class="display-5-custom custom-text mt-5 ml-5 mr-5"
            data-aos="fade-up"
          >
            Get a guide from Pro at a price shared among protégés
          </h3>

          <h1
            style="color: #fff; font-size: xx-large"
            class="display-5-custom mt-5 ml-5 mr-5"
            data-aos="fade-up"
          >
            Join our Visual Class run by many Pros in the rising digital age.
          </h1>
          <br /><br />
          <CRow>
          <CCol sm="4" lg="4">
                <span class="custom-virtual ml-2">VIRTUAL LEARNING</span>
          </CCol>
          <CCol sm="8" lg="8">
            
          <span class="custom-virtual-white ml-2"
            >The Future of Skills Share</span
          >
          </CCol>
          </CRow>
      
        </CCol>
        <CCol
          sm="4"
          lg="4"
          style="background-size: cover; color: #fff"
          :style="{ backgroundImage: `url(${backgroundUrl})` }"
        >
        </CCol>
      </CRow>
    </CCol>
    <CCol style="background-color: #b6e3f9" sm="12" lg="12">
      <br />
      <h1 class="custom-pro-title mt-5 ml-5" data-aos="fade-up">Steps</h1>

      <CRow class="m-2 ml-5">
        <CCol sm="1" lg="1">
          <img style="width: 50px" src="../assets/img/1-1.png" />
        </CCol>
        <CCol sm="2" lg="2">
          <img style="width: 100px" src="../assets/img/1-img.png" />
        </CCol>
        <CCol sm="4" lg="4">
          <span class="display-5-custom"
            ><strong>Search what skills you want to learn. </strong></span
          >
        </CCol>
        <CCol sm="5" lg="5">
          <ul>
            <li class="display-5-custom">Browse from skill page and join.</li>
            <li class="display-5-custom">Schedule placed in Pickiddo Apps.</li>
          </ul>
        </CCol>

        <CCol sm="1" lg="1" class="mt-5">
          <img style="width: 50px" src="../assets/img/2-1.png" />
        </CCol>
        <CCol sm="2" lg="2" class="mt-5">
          <img style="width: 100px" src="../assets/img/2-img.png" />
        </CCol>
        <CCol sm="4" lg="4" class="mt-5">
          <span class="display-5-custom"
            ><strong>Reload eWallet & join the class. </strong></span
          >
        </CCol>
        <CCol sm="5" lg="5" class="mt-5">
          <ul>
            <li class="display-5-custom">TopUp eWallet, ensure enough.</li>
            <li class="display-5-custom">Class link shared under schedule.</li>
          </ul>
        </CCol>

        <CCol sm="1" lg="1" class="mt-5">
          <img style="width: 50px" src="../assets/img/3-1.png" />
        </CCol>
        <CCol sm="2" lg="2" class="mt-5">
          <img style="width: 100px" src="../assets/img/3-img.png" />
        </CCol>
        <CCol sm="4" lg="4" class="mt-5">
          <span class="display-5-custom"
            ><strong>eWallet deducted upon class completion.</strong></span
          >
        </CCol>
        <CCol sm="5" lg="5" class="mt-5">
          <ul>
            <li class="display-5-custom">Class charges shared equally. .</li>
            <li class="display-5-custom">
              Pro get paid, Protege get knowledge.
            </li>
          </ul>
        </CCol>
      </CRow>
      <br />
    </CCol>
    <CCol style="bacground-color: rgb(240, 240, 240)" sm="12" lg="12">
      <h1 class="custom-pro-title mt-5 text-center">Available Pros</h1>
      <hr class="custom-hr-blue" />

      <CRow class="m-4">
        <CCol sm="4" lg="4" class="p-2">
          <h1 class="ml-2 mr-2" data-aos="fade-up">
            <strong>Dr. AMEEN</strong>
          </h1>
          <h3 class="ml-2 mr-2" data-aos="fade-up">Machine Learning</h3>
          <img
            style="max-width: 100%"
            src="../assets/img/ameen.jpg"
            data-aos="fade-up"
          />
          <p class="display-5-custom mt-5">
            I'm lecturer at one of prominent university in Malaysia, teaching ML
          </p>
        </CCol>
        <CCol sm="4" lg="4" class="p-2">
          <h1 class="ml-2 mr-2" data-aos="fade-up">
            <strong>Dr. AAINAA</strong>
          </h1>
          <h3 class="ml-2 mr-2" data-aos="fade-up">GEO Scientist</h3>
          <img
            style="max-width: 100%"
            src="../assets/img/scientist.jpg"
            data-aos="fade-up"
          />
          <p class="display-5-custom mt-5">
            I'm PHD student who focusing in GEO marine analysis.
          </p>
        </CCol>
        <CCol sm="4" lg="4" class="p-2">
          <h1 class="ml-2 mr-2" data-aos="fade-up">
            <strong>Mr. Afiq</strong>
          </h1>
          <h3 class="ml-2 mr-2" data-aos="fade-up">Remisier Expert</h3>
          <img
            style="max-width: 100%"
            src="../assets/img/afiq.jpg"
            data-aos="fade-up"
          />
          <p class="display-5-custom mt-5">
            I have long experience in stock market analysis. Join my class to
            enhance ...
          </p>
        </CCol>
      </CRow>
    </CCol>

    <CCol style="bacground-color: rgb(240, 240, 240)" sm="12" lg="12">
      <h1 class="custom-pro-title mt-5 text-center">Available Classes</h1>
      <hr class="custom-hr-blue" />

      <CRow class="m-4">
        <CCol sm="4" lg="4" class="p-2">
          <h1 class="ml-2 mr-2" data-aos="fade-up">
            <strong>Machine Learning</strong>
          </h1>
          <h3 class="ml-2 mr-2" data-aos="fade-up">A.I.</h3>
          <img
            style="max-width: 100%"
            src="../assets/img/ai.jpg"
            data-aos="fade-up"
          />
          <p class="display-5-custom mt-5">
            All classes involve with teaching on Machine Learning, A.I. and
            related.
          </p>
        </CCol>
        <CCol sm="4" lg="4" class="p-2">
          <h1 class="ml-2 mr-2" data-aos="fade-up">
            <strong>Programming</strong>
          </h1>
          <h3 class="ml-2 mr-2" data-aos="fade-up">BackEnd Development</h3>
          <img
            style="max-width: 100%"
            src="../assets/img/b3.png"
            data-aos="fade-up"
          />
          <p class="display-5-custom mt-5">
            Programming classes with specific on BackEnd development e.g. Go
            Lang.
          </p>
        </CCol>
        <CCol sm="4" lg="4" class="p-2">
          <h1 class="ml-2 mr-2" data-aos="fade-up">
            <strong>Novel writer</strong>
          </h1>
          <h3 class="ml-2 mr-2" data-aos="fade-up">Short story</h3>
          <img
            style="max-width: 100%"
            src="../assets/img/novel.png"
            data-aos="fade-up"
          />
          <p class="display-5-custom mt-5">
            Storytelling classes with many techniques to get the audience's
            intentions.
          </p>
        </CCol>
      </CRow>
    </CCol>
    <CCol
      :style="{ backgroundImage: `url(${backgroundBannerReg})` }"
      sm="12"
      lg="12"
    >
      <CRow>
        <CCol sm="12" lg="12">
          <div class="text-center">
            <img style="max-width: 100%" src="../assets/img/bgPros.png" />
          </div>
        </CCol>
      </CRow>
    </CCol>

    <CCol style="bacground-color: rgb(240, 240, 240)" sm="12" lg="12">
      <CCol sm="12" lg="12">
        <CRow>
          <CCol sm="3" lg="3">
            <h1 class="custom-pro-title mt-3 ml-5" data-aos="fade-up">
              Our Platform Support
            </h1>
            <h5 class="ml-5">How to get in touch with us.</h5>
          </CCol>
          <CCol sm="3" lg="3">
            <h5 class="mt-5 custom-pro-title">PHONE NUMBER</h5>
            <h3 class="display-6">(6019) 3857722</h3>
          </CCol>
          <CCol sm="3" lg="3">
            <h5 class="mt-5 custom-pro-title">EMAIL ADDRESS</h5>
            <h3 class="display-6">Info@pickiddo.com</h3>
          </CCol>
          <CCol sm="3" lg="3">
            <h5 class="mt-5 custom-pro-title">MAILING ADDRESS</h5>
            <h3 class="display-6">
              The Square@One City, T1-14-13,Jalan USJ25/1C,47650 UEP Subang
              Jaya, Selangor Darul Ehsan, Malaysia
            </h3>
          </CCol>
        </CRow>
      </CCol>
    </CCol>
  </div>
</template>

<script>
import backgroundUrl from "../assets/img/bgSkill.png";
import backgroundBannerPro from "../assets/img/bgProNew.png";
import backgroundBannerUrl from "../assets/img/bgProClass.jpg";
import backgroundBannerReg from "../assets/img/bgReg.jpg";
import AOS from "aos";
import "aos/dist/aos.css";

export default {
  name: "ProClass",
  data() {
    return {
      backgroundUrl,
      backgroundBannerPro,
      backgroundBannerUrl,
      backgroundBannerReg,
    };
  },
  created() {
    AOS.init();
  },
};
</script>